/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 *
 * @export
 */
export const AutosavePalAuthSubmissionConflictReason = {
    NotEditable: 'not_editable',
    StaleForm: 'stale_form'
} as const;
export type AutosavePalAuthSubmissionConflictReason = typeof AutosavePalAuthSubmissionConflictReason[keyof typeof AutosavePalAuthSubmissionConflictReason];


export function AutosavePalAuthSubmissionConflictReasonFromJSON(json: any): AutosavePalAuthSubmissionConflictReason {
    return AutosavePalAuthSubmissionConflictReasonFromJSONTyped(json, false);
}

export function AutosavePalAuthSubmissionConflictReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutosavePalAuthSubmissionConflictReason {
    return json as AutosavePalAuthSubmissionConflictReason;
}

export function AutosavePalAuthSubmissionConflictReasonToJSON(value?: AutosavePalAuthSubmissionConflictReason | null): any {
    return value as any;
}

